<header class="fixed top-0 left-0 w-full z-50 xl:px-8 xl:py-1">
  <nav class="border-gray-200 px-4 xl:px-2 py-2.5 bg-amazone-green min-h-[64px] xl:rounded-lg">
    <div class="flex flex-wrap justify-between items-center mx-auto max-w-screen-2xl">
      <a href="index" class="flex items-center">
        <img src="assets/images/brand/Aedbis.brand_256.ico" class="mr-3 h-6 sm:h-9 filter" alt="AEDBIS Logo" />
      </a>
      <div class="flex items-center xl:order-2">
        <app-notification-dropdown class="me-4"></app-notification-dropdown>
        <app-feedback-button></app-feedback-button>
        @if (isLoggedIn) {
          <div class="text-wrap text-center mx-1 rtl:space-x-reverse">
            <p class="text-xs text-white">{{ loggedInUserText }}</p>
            <p class="text-xs text-white">{{ usersRoleText }}</p>
          </div>
          <button
            (click)="logout()"
            class="text-white font-medium rounded-md cursor-pointer text-sm px-4 xl:px-3 py-2 xl:py-2.5 mr-2 hover:bg-amazone-orange focus:outline-none"
            appAgentAction
            agent="header-logout"
            action="logout"
          >
            <app-log-out-icon></app-log-out-icon>
          </button>
        } @else {
          <button
            (click)="login()"
            class="text-white font-medium rounded-lg text-sm px-4 xl:px-5 py-2 xl:py-2.5 mr-2 hover:bg-amazone-orange focus:outline-none"
            appAgentAction
            agent="header-login"
            action="login"
          >
            Log in
          </button>
        }
        <button
          data-collapse-toggle="mobile-menu-2"
          type="button"
          class="inline-flex items-center p-2 ml-1 text-sm rounded-lg xl:hidden focus:outline-none text-gray-300 hover:bg-amazone-orange"
          aria-controls="mobile-menu-2"
          aria-expanded="false"
          appAgentAction
          agent="header-toggle-menu"
          action="toggle"
        >
          <span class="sr-only">Open menu</span>
          <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <svg class="hidden w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            ></path>
          </svg>
        </button>
      </div>
      <div class="hidden justify-between items-center w-full xl:flex xl:w-auto xl:order-1" id="mobile-menu-2">
        @if (isLoggedIn && displayMainMenu) {
          <ul class="flex flex-col mt-4 font-medium xl:flex-row xl:space-x-4 2xl:space-x-8 xl:mt-0">
            <li>
              <a [routerLink]="['/index']" routerLinkActive="header-link-active" class="header-link">Index</a>
            </li>
            <li>
              <a [routerLink]="['/dtc']" routerLinkActive="header-link-active" class="header-link">DTC</a>
            </li>
            <li>
              <a [routerLink]="['/error-message']" routerLinkActive="header-link-active" class="header-link"
                >Error Message</a
              >
            </li>
            <li>
              <a [routerLink]="['/sw-part-number/overview']" routerLinkActive="header-link-active" class="header-link"
                >SW Part Number</a
              >
            </li>
            <li>
              <a
                [routerLink]="['/error-code']"
                routerLinkActive="header-link-active"
                (isActiveChange)="errorCodeRouteIsActive = $event"
                class="header-link"
                >Legacy Error Code</a
              >
            </li>
            <li>
              <a
                [routerLink]="['/nw-number/overview']"
                routerLinkActive="header-link-active"
                (isActiveChange)="errorCodeRouteIsActive = $event"
                class="header-link"
                >NW Number</a
              >
            </li>

            <li>
              <button
                id="dropdownNavbarLink"
                data-dropdown-toggle="dropdownNavbar"
                class="flex items-baseline justify-between w-full py-2 px-3 text-white md:hover:bg-transparent md:border-0 md:hover:text-white md:p-0 md:w-auto cursor-pointer rounded-md"
                appAgentAction
                agent="header-toggle-user-menu"
                action="toggle"
              >
                &nbsp;
                <svg
                  class="w-2.5 h-2.5 ms-2.5"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 10 6"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m1 1 4 4 4-4"
                  />
                </svg>
              </button>
              <div
                id="dropdownNavbar"
                class="z-10 hidden font-normal bg-amazone-green divide-y divide-gray-100 rounded-lg shadow-md w-full xl:w-44 ring-1 ring-gray-50"
              >
                <ul class="py-2 text-sm text-gray-300" aria-labelledby="dropdownLargeButton">
                  <li>
                    <button
                      *appIfPolicySatisfied="policy.canDownloadApiCallLogs"
                      (click)="downloadApiCallLogs()"
                      class="block px-4 py-2 text-white items-center text-left cursor-pointer hover:bg-amazone-orange w-full"
                      appAgentAction
                      agent="header-download-api-logs"
                      action="download"
                    >
                      Download API logs
                    </button>
                  </li>
                </ul>
              </div>
            </li>
            <!-- <li>
            <a
              href="#"
              routerLinkActive="text-white"
              class="block py-2 pr-4 pl-3 text-gray-300  xl:border-0 xl:p-0 hover:bg-gray-700 hover:text-white xl:hover:bg-transparent border-gray-700"
              >Settings</a
            >
          </li> -->
          </ul>
        }
      </div>
    </div>
  </nav>
</header>
